import { EmailTemplateList } from '@dealstack/frontend/shared/components/EmailTemplates/components/EmailTemplateList';
import { StyledEmailTemplatesContainer } from '@dealstack/frontend/shared/components/EmailTemplates/styles';
import { EmailTemplateScopeKind } from '@dealstack/frontend/shared/components/EmailTemplates/EmailTemplates.types';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
	mipId: string;
}

export const ProgrammeEmailTemplates = ({ mipId }: Props) => {
	const navigate = useNavigate();
	const scope = useMemo(() => ({ kind: EmailTemplateScopeKind.PROGRAMME, id: mipId }), [mipId]);

	return (
		<StyledEmailTemplatesContainer>
			<EmailTemplateList scope={scope} onEdit={(templateType) => navigate(templateType)} />
		</StyledEmailTemplatesContainer>
	);
};
